import React, { useCallback } from 'react';
import { LayoutGrid, X } from 'lucide-react';
import ThumbnailImage from './ThumbnailImage';

const PDFThumbnails = ({
  showThumbnails, setShowThumbnails,
  numPages, pageNumber, goToPage, documentId,
  continuousMode = false, containerRef = null,
  toolbarHeight = 56,
}) => {
  if (!showThumbnails) return null;

  // En modo continuo: scroll suave a la página dentro del container (mismo patrón que PDFTableOfContents).
  // En modo página individual: goToPage tradicional.
  const handleThumbClick = useCallback((pg) => {
    if (continuousMode && containerRef?.current) {
      const container = containerRef.current;
      const targetEl = container.querySelector(`[data-page-num="${pg}"]`);
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    goToPage(pg);
  }, [continuousMode, containerRef, goToPage]);

  return (
    <div
      className={`${continuousMode ? 'fixed left-0 z-[60]' : 'absolute top-0 left-0 h-full z-30'} w-48 md:w-56 bg-slate-800/95 backdrop-blur-sm border-r border-slate-700 overflow-hidden flex flex-col`}
      style={continuousMode ? { top: `${toolbarHeight}px`, height: `calc(100vh - ${toolbarHeight}px)` } : undefined}
    >
      <div className="p-3 border-b border-slate-700 flex items-center justify-between">
        <h3 className="text-white font-medium text-sm flex items-center gap-2">
          <LayoutGrid className="h-4 w-4 text-teal-400" />
          Miniaturas
        </h3>
        <button 
          onClick={() => setShowThumbnails(false)}
          className="text-slate-400 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2" data-testid="thumbnails-panel">
        {Array.from({ length: numPages }, (_, i) => i + 1).map((pg) => (
          <button
            key={pg}
            onClick={() => { handleThumbClick(pg); }}
            className={`w-full rounded-lg overflow-hidden border-2 transition-all ${
              pageNumber === pg 
                ? 'border-teal-400 shadow-lg shadow-teal-500/20' 
                : 'border-transparent hover:border-slate-500'
            }`}
            data-testid={`thumbnail-page-${pg}`}
          >
            <ThumbnailImage documentId={documentId} pageNum={pg} alt={`Pag ${pg}`} />
            <div className={`text-center py-1 text-xs ${
              pageNumber === pg ? 'text-teal-300 bg-teal-500/20' : 'text-slate-400 bg-slate-700/50'
            }`}>
              {pg}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PDFThumbnails;
